<script lang="ts" setup>
import type { LabelProps } from "radix-vue";

defineProps<LabelProps & {

}>();

const { error, formItemId } = useFormField();
</script>

<template>
  <label
    class="form-label"
    :class="{ error: error }"
    :for="formItemId">
    <slot />
  </label>
</template>

<style lang="scss" scoped>
.form-label {
  display: block;
  font-weight: 600;
}
</style>
